(function () {
  // Only allow on /pages/w... (adjust if your slug differs)
  var isWplusDashboard = /^\/pages\/w(\/|$|\?|#)/.test(location.pathname);
  if (!isWplusDashboard) return;

/* SAFE STORAGE: uses localStorage if allowed, else in-memory */
window.WPLUS_STORE=(function(){
  let mem=[]; let ls=null;
  try{ ls=window.localStorage; const k="__wplus_test__"; ls.setItem(k,"1"); ls.removeItem(k);}catch(e){ls=null;}
  return {
    hasLS: !!ls,
    load(key){ if(!ls) return mem; try{ return JSON.parse(ls.getItem(key)||"[]"); }catch(e){ return []; } },
    save(key,arr){ if(ls){ try{ ls.setItem(key, JSON.stringify(arr)); }catch(e){} } mem=Array.isArray(arr)?arr:[]; window.WPLUS?.updatePointsPill?.(); }
  };
})();

  /*-- ================== DOWNLOADS MODAL ================== */
(function(){
  var openBtn = document.getElementById('open-downloads-modal');
  var modal   = document.getElementById('downloads-modal');
  var overlay = document.getElementById('downloads-modal-overlay');
  var closeBtn= document.getElementById('close-downloads-modal');

  function openModal(e){
    if (e) e.preventDefault();
    overlay.style.display = 'block';
    modal.style.display   = 'grid';     /* header / search / body */
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }
  function closeModal(e){
    if (e) e.preventDefault();
    overlay.style.display = 'none';
    modal.style.display   = 'none';
    document.body.style.overflow = '';
    if (openBtn) openBtn.focus();
  }

  if (openBtn){ openBtn.addEventListener('click', openModal); }
  overlay.addEventListener('click', closeModal);
  closeBtn.addEventListener('click', closeModal);
  document.addEventListener('keydown', function(ev){
    if (ev.key === 'Escape') closeModal();
  });

  /* Build per-product Download buttons */
  function addDownloadButtons(){
    var dataEl = document.getElementById('wplus-order-index');
    if (!dataEl) return;
    var rows = [];
    try { rows = JSON.parse(dataEl.textContent || '[]'); } catch(_){ rows = []; }

    var latestByHandle = {};
    for (var i=0;i<rows.length;i++){
      var h = rows[i] && rows[i].handle;
      var id = Number(rows[i] && rows[i].order_id);
      if (!h || !id) continue;
      if (!latestByHandle[h] || id > latestByHandle[h]) latestByHandle[h] = id;
    }

    var origin = (window.top && window.top.location ? window.top.location.origin : window.location.origin);

    document.querySelectorAll('#modal-owned-grid .owned-item').forEach(function(li){
      var handle = li.getAttribute('data-handle');
      var orderId = latestByHandle[handle];

      var actions = li.querySelector('.owned-actions');
      if (!actions){
        actions = document.createElement('div');
        actions.className = 'owned-actions';
        li.appendChild(actions);
      }
      actions.querySelectorAll('.dl-download').forEach(function(a){ a.remove(); });

      if (orderId){
        var a = document.createElement('a');
        a.className = 'dl-download';
        a.href = origin + '/apps/downloads/orders/' + orderId + '/';
        a.target = '_blank';
        a.rel = 'noopener';
        a.innerHTML = '<svg aria-hidden="true" viewBox="0 0 24 24" fill="currentColor"><path d="M12 3a1 1 0 0 1 1 1v8.586l2.293-2.293a1 1 0 1 1 1.414 1.414l-4 4a1 1 0 0 1-1.414 0l-4-4A1 1 0 0 1 8.707 10.293L11 12.586V4a1 1 0 0 1 1-1z"></path><path d="M5 19a1 1 0 1 0 0 2h14a1 1 0 1 0 0-2H5z"></path></svg><span>Download</span>';
        actions.prepend(a);
      }
    });
  }

  addDownloadButtons();

  /* Live search filter */
  (function initDownloadSearch(){
    var input = document.getElementById('dl-search-input');
    if (!input) return;
    var items = Array.prototype.slice.call(document.querySelectorAll('#modal-owned-grid .owned-item'));
    items.forEach(function(li){
      var title = (li.querySelector('.owned-title')?.textContent || '').trim();
      var norm  = title.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
      li.dataset.search = norm;
    });

    function filter(){
      var q = (input.value || '').trim();
      var normQ = q.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
      var tokens = normQ.split(/\s+/).filter(Boolean);

      items.forEach(function(li){
        if (tokens.length === 0) { li.classList.remove('is-hidden'); return; }
        var hay = li.dataset.search || '';
        var ok = true;
        for (var i=0;i<tokens.length;i++){
          if (hay.indexOf(tokens[i]) === -1) { ok = false; break; }
        }
        li.classList.toggle('is-hidden', !ok);
      });
    }

    input.addEventListener('input', filter);
  })();
})();



/* ---- W+ OWNED shim: expose Sets for hydrator/quick-view ---- */
(function(){
  let t = null;
  function debounce(fn){ clearTimeout(t); t = setTimeout(fn, 120); }

  function readOwned(){
    try{
      const topDoc = (window.top && window.top.document) ? window.top.document : document;
      const raw = topDoc.getElementById('wplus-owned-json')?.textContent || '[]';
      const arr = JSON.parse(raw);

      // Build sets once; hydrator reads these via getOwnedSets()
      const variants = new Set(arr.map(o => String(o.variant_id)).filter(Boolean));
      const products = new Set(arr.map(o => String(o.product_id)).filter(Boolean));

      window.WPLUS_OWNED = { variants, products };
    }catch(_){}
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', readOwned);
  } else {
    readOwned();
  }

  // If PageFly swaps/loads content later, re-read once (debounced)
  try{
    const mo = new MutationObserver(() => debounce(readOwned));
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }catch(_){}
})();





/* ================== ADD REMOVE LOGIC (HYDRATOR) ================== */
/**
 * PageFly iframe:
 * - Hydrates .wplus-btn -> OWNED / REMOVE / BUY / ADD (labels only)
 * - Updates a local selection store on click so re-hydrates are stable
 * - Uses a short optimism map so a just-added item shows Remove immediately
 * - Posts messages to the top window (cart) and nudges a state refresh
 */
(function(){
  const CH  = 'wplus-v1';
  const KEY = 'wplus_selected';

  /* ---------------- helpers ---------------- */
  function openDownloadsModal(){
    try { window.top.document.getElementById('open-downloads-modal')?.click(); } catch(_){}
  }
  function getProductUrlFromTile(btn){
    const tile = btn.closest('[data-pf-type="Product"], [data-pf-type="FlexBlock"], .wplus-card') || btn.parentElement;
    const a = tile && tile.querySelector('a[href*="/products/"]');
    return (btn.getAttribute('data-wplus-url') || btn.dataset.wplusUrl || (a && a.href)) || '';
  }
  function getOwnedSets(){
    const src = window.WPLUS_OWNED || (window.top && window.top.WPLUS_OWNED) || {};
    const variants = src.variants instanceof Set ? src.variants : new Set(src.variants||[]);
    const products = src.products instanceof Set ? src.products : new Set(src.products||[]);
    return { variants, products };
  }
  function getRemainingPoints(){
    try { if (window.WPLUS?.getRemainingPoints) return +window.WPLUS.getRemainingPoints()||0; } catch(_){}
    try { if (window.top?.WPLUS?.getRemainingPoints) return +window.top.WPLUS.getRemainingPoints()||0; } catch(_){}
    const n = +document.getElementById('wplus-points-remaining')?.textContent || 0;
    return isNaN(n) ? 0 : n;
  }

  /* ---- local selection store ---- */
  function storeLoad(){
    try{
      if (window.WPLUS_STORE && typeof WPLUS_STORE.load === 'function'){
        return WPLUS_STORE.load(KEY) || [];
      }
    }catch(_){}
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); }
    catch(_){ return []; }
  }
  function storeSave(arr){
    try{
      if (window.WPLUS_STORE && typeof WPLUS_STORE.save === 'function'){
        WPLUS_STORE.save(KEY, arr); return;
      }
    }catch(_){}
    try { localStorage.setItem(KEY, JSON.stringify(arr)); } catch(_){}
  }
  function storeAdd(variantId, cost){
    const id = Number(variantId)||0;
    const c  = Number(cost)||0;
    if (!id) return;
    const arr = storeLoad();
    if (!arr.some(x => Number(x?.variantId ?? x?.id ?? x) === id)){
      arr.push({ variantId:id, cost:c });
      storeSave(arr);
    }
  }
  function storeRemove(variantId){
    const id = Number(variantId)||0;
    if (!id) return;
    const arr = storeLoad();
    const next = arr.filter(x => Number(x?.variantId ?? x?.id ?? x) !== id);
    storeSave(next);
  }
  function isVariantSelected(variantId){
    const id = Number(variantId)||0;
    if (!id) return false;
    const arr = storeLoad();
    return Array.isArray(arr) && arr.some(x => Number(x?.variantId ?? x?.id ?? x) === id);
  }

  /* ---- optimism (shared with top window) ---- */
  function markOptimisticAdd(vid){
    try{
      const top = window.top || window;
      top.WPLUS_OPTIMISM = top.WPLUS_OPTIMISM || { adds:new Map(), ttl:2500 };
      top.WPLUS_OPTIMISM.adds.set(String(vid), Date.now() + top.WPLUS_OPTIMISM.ttl);
    }catch(_){}
  }
  function clearOptimisticAdd(vid){
    try{ (window.top?.WPLUS_OPTIMISM?.adds)?.delete(String(vid)); }catch(_){}
  }
  function isOptimisticallySelected(vid){
    try{
      const exp = window.top?.WPLUS_OPTIMISM?.adds?.get(String(vid))
               ?? window.WPLUS_OPTIMISM?.adds?.get(String(vid));
      return !!exp && exp > Date.now();
    }catch(_){ return false; }
  }
  function nudgeStateSyncSoon(){
    try{ (window.top || window).dispatchEvent(new Event('wplus:state-sync')); }catch(_){}
  }

  /* --------------- label setters --------------- */
  function setOwned(btn){
    btn.classList.remove('wplus-btn--buy','wplus-selected');
    btn.classList.add('wplus-btn--owned');
    btn.dataset.wplusMode = 'owned';
    btn.innerHTML =
      '<span class="wplus-owned-ico" aria-hidden="true">✓</span>' +
      '<span class="wplus-owned-label">Owned</span>';
  }
  function setRemove(btn){
    btn.classList.remove('wplus-btn--buy','wplus-btn--owned');
    btn.dataset.wplusMode = '';
    btn.textContent = 'Remove';
    btn.classList.add('wplus-selected');
  }
  function setBuy(btn, missing){
    btn.classList.add('wplus-btn--buy');
    btn.classList.remove('wplus-btn--owned','wplus-selected');
    btn.dataset.wplusMode = 'buy';
    const miss = Math.max(0, Number(missing)||0);
    if (miss > 0){
      btn.innerHTML =
        'Buy&nbsp;<span class="wplus-miss">· ' +
          '<span class="wplus-miss-pts">' + miss + ' PTS</span>' +
        '</span>';
    } else {
      btn.textContent = 'Buy';
    }
  }
  function setAdd(btn, cost){
    btn.classList.remove('wplus-btn--buy','wplus-btn--owned','wplus-selected');
    btn.dataset.wplusMode = '';
    const c = Number(cost) || 0;
    btn.innerHTML = 'ADD&nbsp;<span class="wplus-pts">· ' + String(c) + ' PTS</span>';
  }

  /* ---------------- hydrate ---------------- */
  function hydrateBtn(btn){
    // DO NOT touch QV content; that script owns its labels
    if (!btn || btn.closest('#wplusqv-content')) return;

    const vid = btn.getAttribute('data-wplus-variant-id') ||
                btn.dataset.wplusVariantId ||
                btn.getAttribute('data-variant-id') ||
                btn.dataset.variantId || '';

    const pid = btn.getAttribute('data-wplus-product-id') ||
                btn.dataset.wplusProductId || '';

    const cost = +(btn.getAttribute('data-wplus-cost') ||
                   btn.dataset.wplusCost ||
                   btn.getAttribute('data-cost') ||
                   btn.dataset.cost || '0') || 0;

    // 1) OWNED wins
    const OWNED = getOwnedSets();
    if ((vid && OWNED.variants.has(String(vid))) || (pid && OWNED.products.has(String(pid)))) {
      setOwned(btn); return;
    }
    // 2) Selected (store or optimistic)
    if (vid && (isVariantSelected(vid) || isOptimisticallySelected(vid))) {
      setRemove(btn); return;
    }
    // 3) Points gate (pass how many points short)
    const remaining = getRemainingPoints();
    if (cost > remaining) {
      setBuy(btn, cost - remaining);
    } else {
      setAdd(btn, cost);
    }
  }
  function hydrateAll(){
    document.querySelectorAll('.wplus-btn').forEach(hydrateBtn);
  }

/* ---------------- BUY (not enough points) — intercept & navigate (pre-apply code) ---------------- */
(function(){
  function getProductUrlFromBtn(btn){
    const tile = btn.closest('[data-pf-type="Product"], [data-pf-type="FlexBlock"], .wplus-card') || btn?.parentElement;
    const explicit = btn?.getAttribute('data-wplus-url') || btn?.dataset?.wplusUrl;
    if (explicit) return explicit;
    const a = tile && tile.querySelector('a[href*="/products/"]');
    return a ? a.href : '/';
  }
  function getRemainingPoints(){
    try { if (window.WPLUS?.getRemainingPoints) return +window.WPLUS.getRemainingPoints()||0; } catch(_){}
    try { if (window.top?.WPLUS?.getRemainingPoints) return +window.top.WPLUS.getRemainingPoints()||0; } catch(_){}
    const n = +document.getElementById('wplus-points-remaining')?.textContent || 0;
    return isNaN(n) ? 0 : n;
  }
  function btnCost(btn){
    return +(btn.getAttribute('data-wplus-cost') || btn.dataset.wplusCost ||
             btn.getAttribute('data-cost') || btn.dataset.cost || '0') || 0;
  }
  function isOwned(btn){ return btn?.dataset?.wplusMode === 'owned' || btn?.classList?.contains('wplus-btn--owned'); }
  function isSelected(btn){ return btn?.classList?.contains('wplus-selected'); }
  function shouldBuy(btn){
    if (!btn || isOwned(btn) || isSelected(btn)) return false;
    if (btn.dataset?.wplusMode === 'buy' || btn.classList.contains('wplus-btn--buy')) return true;
    return btnCost(btn) > getRemainingPoints();
  }
  function normalizeBuyButtons(root){
    (root || document).querySelectorAll('.wplus-btn').forEach(b=>{
      if (shouldBuy(b) && b.tagName === 'BUTTON') b.type = 'button';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => normalizeBuyButtons(document));
  } else {
    normalizeBuyButtons(document);
  }
  document.addEventListener('wplus:cart-updated', () => normalizeBuyButtons(document));
  window.addEventListener('message', (e)=>{
    const d = e && e.data;
    if (d && d.__wplus__ && d.channel === 'wplus-v1') normalizeBuyButtons(document);
  });

  // Make PDP land WITH code already applied, only show loading text if redeem is slow (no extra delay)
  async function goToPDPWithPreApplied(btn){
    const href   = getProductUrlFromBtn(btn) || '/';
    const topWin = (window.top || window);
    const api    = topWin.WP_REDEEM || window.WP_REDEEM;

    // If API isn’t there, go immediately with no UI changes.
    if (!api || typeof api.redeem !== 'function' || typeof api.applyCode !== 'function') {
      topWin.location.href = href;
      return;
    }

    // Prepare optional UI (shown only if slow)
    const oldHTML = btn.innerHTML;
    const oldAria = btn.getAttribute('aria-label');
    const wasDisabled = btn.disabled === true;

    let shown = false;
    const showTimer = setTimeout(() => {
      shown = true;
      btn.classList.add('is-busy');
      btn.setAttribute('aria-busy','true');
      btn.setAttribute('aria-label','Applying your member discount…');
      btn.innerHTML = 'Applying your member discount…';
      btn.disabled = true;
    }, 250); // show only if redeem takes longer than this

    const restore = () => {
      clearTimeout(showTimer);
      if (!shown) return; // nothing to restore if we never changed UI
      btn.classList.remove('is-busy');
      btn.removeAttribute('aria-busy');
      if (oldAria != null) btn.setAttribute('aria-label', oldAria); else btn.removeAttribute('aria-label');
      btn.innerHTML = oldHTML;
      btn.disabled = wasDisabled;
    };

    try {
      const res = await api.redeem();
      clearTimeout(showTimer);

      if (res && res.ok && res.code) {
        // Navigate via /discount/<code>?redirect=<PDP> so PDP loads with code already applied
        api.applyCode(res.code, href);
        return;
      }

      // Fallback: go straight to PDP (no autorun; avoids post-load refresh loop)
      topWin.location.href = href;
    } catch (_) {
      clearTimeout(showTimer);
      restore();
    }
  }

  function killAndNav(e, btn){
    e.preventDefault();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    e.stopPropagation();
    goToPDPWithPreApplied(btn);
  }

  // Capture early and divert BUY clicks
  ['pointerdown','click'].forEach(evt=>{
    document.addEventListener(evt, function(e){
      const btn = e.target.closest && e.target.closest('.wplus-btn');
      if (!btn) return;
      if (!shouldBuy(btn)) return;
      killAndNav(e, btn);
    }, true);
  });

  // Block any form submit that could slip through
  document.addEventListener('submit', function(e){
    const active = document.activeElement;
    const btn = active && active.closest && active.closest('.wplus-btn');
    if (!btn) return;
    if (!shouldBuy(btn)) return;
    e.preventDefault();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    e.stopPropagation();
  }, true);
})();


  /* ---------------- clicks (normal ADD / REMOVE) ---------------- */
  document.addEventListener('click', function(e){
    const b = e.target.closest('.wplus-btn');
    if (!b) return; // do not interfere with other click handlers

    const mode = b.dataset?.wplusMode || (b.classList.contains('wplus-btn--buy') ? 'buy' : '');

    // OWNED -> downloads
    if (mode === 'owned'){
      e.preventDefault(); e.stopPropagation();
      openDownloadsModal();
      return;
    }

    // BUY -> handled by BUY interceptor; do not run ADD/REMOVE
    if (mode === 'buy') {
      e.preventDefault();
      e.stopPropagation();
      return;
    }

    // Normal ADD/REMOVE
    const variantId =
      b.getAttribute('data-wplus-variant-id') || b.dataset?.wplusVariantId ||
      b.getAttribute('data-variant-id')       || b.dataset?.variantId || '';

    const cost = Number(
      b.getAttribute('data-wplus-cost') || b.dataset?.wplusCost ||
      b.getAttribute('data-cost')        || b.dataset?.cost || '0'
    ) || 0;

    if (!variantId) return;

    const isSelectedNow = b.classList.contains('wplus-selected');
    const type = isSelectedNow ? 'REMOVE' : 'ADD';

    // local-first so re-hydrates are stable
    if (type === 'ADD'){
      storeAdd(variantId, cost);
      markOptimisticAdd(variantId);
      setRemove(b);
    }else{
      storeRemove(variantId);
      clearOptimisticAdd(variantId);
      setAdd(b, cost);
    }

    // post to TOP (server cart)
    window.top.postMessage(
      { __wplus__: true, channel: CH, reply: false, txn: 'diag' + Date.now(), type, variantId, cost },
      '*'
    );

    // ask top to re-sync
    nudgeStateSyncSoon();

    // open slidecart
    try {
      window.top.document.dispatchEvent(new Event('slidecart:refresh'));
      window.top.document.dispatchEvent(new Event('slidecart:open'));
    } catch(_){}
  }, true);

  /* --------------- keep hydrated --------------- */
  document.addEventListener('DOMContentLoaded', hydrateAll);
  document.addEventListener('wplus:cart-updated', hydrateAll);
  window.addEventListener('storage', hydrateAll);
  window.addEventListener('message', (e)=>{
    const d = e && e.data;
    if (d && d.__wplus__ && d.channel === CH) hydrateAll();
  });

  // single renderer hook
  window.WPLUS = window.WPLUS || {};
  window.WPLUS.renderTileCTAs = hydrateAll;
})();  // <-- IMPORTANT: close the hydrator IIFE





/* ATC MODAL RENDER */

(function(){
  const els = {
    triggers: Array.from(document.querySelectorAll('.wplus-selected-trigger')),
    countSticky: document.getElementById('wplus-count-sticky'),
    countFab: document.getElementById('wplus-count-fab'),
    fab: document.querySelector('.wplus-fab'),
    modal: document.getElementById('wplus-modal'),
    body: document.getElementById('wplus-modal-body'),
    redeem: document.getElementById('wplus-redeem-btn'),
  };

  function openModal(){ els.modal.setAttribute('aria-hidden','false'); }
  function closeModal(){ els.modal.setAttribute('aria-hidden','true'); }
  document.addEventListener('click', e => { if (e.target.closest('[data-close]')) closeModal(); });

  async function getCart(){
    const r = await fetch('/cart.js?t=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'application/json' }
    });
    return r.json();
  }

  function setCounts(n){
    if (els.countSticky) els.countSticky.textContent = n;
    if (els.countFab) els.countFab.textContent = n;
    if (els.fab) els.fab.classList.toggle('hidden', n === 0);
  }

  function isPack(item){
    return true; // keep filtering wide; tighten if you want by product_type
  }

  function renderModal(cart){
    const items = (cart.items || [])
      .map((it, i) => ({ it, line: i + 1, key: it.key }))   // include immutable key
      .filter(x => isPack(x.it));

    if (!items.length){
      els.body.innerHTML = '<p style="padding:.75rem 0;opacity:.8;">No packs selected yet.</p>';
      return;
    }

    const html = items.map(({it, line, key}) => {
      const img = it.image || (it.featured_image && it.featured_image.url) || '';
      const title = it.product_title || it.title || '';
      return `
        <div class="wplus-item" data-line="${line}" data-key="${key}">
          <img src="${img}" alt="">
          <div><div class="t">${title}</div></div>
          <div class="wplus-actions">
            <button class="wplus-link" data-action="remove" data-line="${line}" data-key="${key}">Remove</button>
          </div>
        </div>
      `;
    }).join('');
    els.body.innerHTML = html;
  }

  async function refreshCounts(){
    const cart = await getCart();
    setCounts(cart && typeof cart.item_count === 'number' ? cart.item_count : 0);
  }

  // Open modal from both triggers
  els.triggers.forEach(btn => btn.addEventListener('click', async () => {
    const cart = await getCart();
    renderModal(cart);
    openModal();
  }));

  // ---- Reconcile local selection store with the real cart (fixes points getting stuck)
  function reconcileStoreWithCart(cart){
    try{
      if (!window.WPLUS_STORE) return;

      const KEY = 'wplus_selected';
      const inCart = new Set((cart.items || []).map(i => Number(i.variant_id)));

      // normalize any entry shape to a numeric variant id
      const normId = (x) => {
        if (x == null) return null;
        if (typeof x === 'number') return x || null;
        if (typeof x === 'string') return Number(x) || null;
        if (typeof x === 'object'){
          const cand = x.id ?? x.variant_id ?? x.variantId ?? x.vid ?? x.variant;
          return cand != null ? Number(cand) || null : null;
        }
        return null;
      };

      const arr = WPLUS_STORE.load(KEY) || [];

      // keep only entries that are still in the server cart
      let filtered = arr
        .map(e => ({ id: normId(e), cost: Number(e?.cost ?? 0) || 0 }))
        .filter(e => e.id && inCart.has(e.id));

      // IMPORTANT: do NOT rebuild from selected buttons when the cart is empty.
      // Only attempt rebuild if the server cart still has items.
      if (inCart.size > 0 && arr.length && filtered.length === 0){
        const selected = Array.from(
          document.querySelectorAll('.wplus-btn.wplus-selected[data-wplus-variant-id]')
        );
        filtered = selected.map(b => ({
          id: Number(b.getAttribute('data-wplus-variant-id')) || 0,
          cost: Number(b.getAttribute('data-wplus-cost')) || 0
        })).filter(e => e.id && inCart.has(e.id));
      }

      WPLUS_STORE.save(KEY, filtered);

      // repaint pill after the write to avoid ordering races
      queueMicrotask(() => { try { window.WPLUS?.updatePointsPill?.(); } catch(_) {} });

    }catch(e){
      console.warn('[wplus] reconcileStoreWithCart error', e);
    }
  }

  // ---- Prevent rapid-fire remove from racing
  let inflight = false;
  async function changeCart(payload){
    if (inflight) return false;
    inflight = true;
    try{
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });
      return true;
    } finally {
      inflight = false;
    }
  }

  // Modal actions
  els.modal.addEventListener('click', async e => {
    const btn = e.target.closest('button[data-action]');
    if (!btn) return;

    if (btn.getAttribute('data-action') === 'remove') {
      btn.disabled = true;

      const key  = btn.getAttribute('data-key');
      const line = parseInt(btn.getAttribute('data-line'), 10) || 1;

      // Prefer immutable key; fall back to line only if needed
      const ok = key
        ? await changeCart({ id: key, quantity: 0 })
        : await changeCart({ line, quantity: 0 });

      // Pull fresh cart AFTER server confirms
      const cart = await getCart();
      setCounts(cart.item_count || 0);
      renderModal(cart);

      // Keep local selection consistent so points recalc correctly
      reconcileStoreWithCart(cart);

      // Notify the rest of the page (cards, locks, etc.)
      window.dispatchEvent(new Event('wplus:cart-updated'));

      // Also repaint pill immediately if available
      try { window.WPLUS?.updatePointsPill?.(); } catch(_) {}

      btn.disabled = false;
    }
  });

  // Buttons — Normal Redeem (iframe → apply code → go to checkout)
  (function(){
    const btn = document.getElementById('wplus-redeem-btn');
    if (!btn) return;

    let busy = false; // ignore rapid double-clicks without disabling UI
btn.addEventListener('click', async (e) => {
  e.preventDefault();
  if (busy) return;
  busy = true;

  // NEW: instant visual feedback
  const _old = btn.textContent;
  btn.textContent = 'Applying your member discount…';
  btn.classList.add('is-busy');

  try {
    const api = (window.top && window.top.WP_REDEEM) || window.WP_REDEEM;

        if (!api || typeof api.redeem !== 'function') {
          console.warn('[WPLUS] WP_REDEEM not ready');
          return;
        }
        const res = await api.redeem();
        if (res && res.ok && res.code) {
          api.applyCode(res.code, '/checkout'); // apply then send to checkout
        } else {
          alert(res?.error ? ('Redeem failed: ' + res.error)
                           : 'Could not create discount. Please try again.');
        }
} finally {
  busy = false;
  btn.classList.remove('is-busy');
  btn.textContent = _old;
}

    }, true);
  })();

  // Initial counts
  refreshCounts();

  // Stay in sync with your existing add to cart updates
  window.addEventListener('wplus:cart-updated', refreshCounts);
})();





 /**
  * ATC PRODUCT SYNC
 * Product Sync (top window)
 * - Toggles state classes only (no text writes).
 * - Drops stale fetches.
 * - Respects optimistic adds from ADD REMOVE LOGIC.
 */
(function () {
  let runId = 0;                     // bump per refresh to drop stale results

  function isOptimisticallySelected(vid){
    try{
      const m = (window.WPLUS_OPTIMISM && window.WPLUS_OPTIMISM.adds) || null;
      if (!m) return false;
      const exp = m.get(String(vid));
      if (!exp) return false;
      if (Date.now() <= exp) return true;
      m.delete(String(vid));
      return false;
    }catch(_){ return false; }
  }

  async function getCart(runToken) {
    const r = await fetch('/cart.js?t=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    });
    const data = await r.json();
    // stale guard: if a newer run started, ignore this result
    if (runToken !== runId) throw new Error('stale');
    return data;
  }

  function getRemaining() {
    if (window.WPLUS?.getRemainingPoints) return Number(window.WPLUS.getRemainingPoints()) || 0;
    const initial = Number(window.WPLUS?.initialPoints || 0);
    const store = (window.WPLUS_STORE && window.WPLUS_STORE.load('wplus_selected')) || [];
    const used = store.reduce((a, x) => a + (Number(x?.cost ?? x) || 0), 0);
    return Math.max(0, initial - used);
  }

  function getTile(btn) {
    return (
      btn.closest('[data-pf-type="FlexBlock"], [data-pf-type="Product"], .wplus-card') ||
      btn.parentElement || null
    );
  }

  function getProductRoot(btn) {
    return (
      btn.closest('[data-pf-type="ProductBox"]') ||
      btn.closest('form.pf-product-form') ||
      btn.closest('[data-product-id]') ||
      getTile(btn)
    );
  }

  function toggleMediaLock(btn, locked) {
    const root = getProductRoot(btn);
    if (!root) return;
    const img =
      root.querySelector('.pf-slide-main-media.is-current img') ||
      root.querySelector('[data-pf-type="MediaMain2"] img') ||
      root.querySelector('[data-pf-type="ProductMedia2"] img') ||
      root.querySelector('.pf-main-media img') ||
      root.querySelector('picture img') ||
      root.querySelector('img');
    if (img) img.classList.toggle('wplus-media-dim', !!locked);
  }

  async function refreshCards() {
    const myRun = ++runId;

    let cart;
    try { cart = await getCart(myRun); }
    catch (e) { if (String(e.message) === 'stale') return; else return; }

    const inCart = new Set((cart.items || []).map(li => Number(li.variant_id)));
    const remaining = getRemaining();

    document.querySelectorAll('[data-wplus-variant-id]').forEach((btn) => {
      // never touch the quick-view CTA
      if (btn.closest('#wplusqv-content')) return;

      const vid  = Number(btn.getAttribute('data-wplus-variant-id'));
      const cost = Number(btn.getAttribute('data-wplus-cost')) || 0;
      const tile = getTile(btn);

      // lock if user can't afford and it's not selected (server) nor optimistic selected (client)
      const consideredIn = inCart.has(vid) || isOptimisticallySelected(vid);
      const locked = remaining < cost && !consideredIn;

      if (tile) tile.classList.toggle('wplus-card-locked', locked);
      toggleMediaLock(btn, locked);

      // state classes only (no text)
      if (locked) {
        btn.dataset.wplusMode = 'buy';
        btn.classList.add('wplus-btn--buy');
        btn.classList.remove('wplus-selected');
      } else {
        btn.dataset.wplusMode = '';
        btn.classList.remove('wplus-btn--buy');
        btn.classList.toggle('wplus-selected', consideredIn);
      }
    });

    // one single writer paints labels after classes are correct
    try { window.WPLUS?.renderTileCTAs?.(); } catch(_) {}
  }

  // initial + keep in sync
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshCards);
  } else {
    refreshCards();
  }

  // after cart changes
  window.addEventListener('wplus:cart-updated', refreshCards);
  // run immediately after an optimistic click
  window.addEventListener('wplus:state-sync', refreshCards);
})();



 /**
  * LOAD GRID FIX
 */

(function () {
  const TILE_SEL = '.pf-slide, [data-pf-type="ProductItem"], .pf-product-item';
  const isVisible = el => el && el.offsetParent !== null && getComputedStyle(el).display !== 'none';
  const text = el => (el?.textContent || el?.getAttribute?.('aria-label') || '').trim();
  const normalize = href => new URL(href, location.href).href;
  const dbg = (...a) => (window.WPLUS_DEBUG_APPEND ? console.log('[WPLUS]', ...a) : 0);

  function moveLoadMoreBelow(list, a) {
    const btnWrap = a.parentElement;
    const parent  = list.parentElement || list;
    if (!btnWrap || !parent) return;
    if (btnWrap.parentElement !== parent || btnWrap.previousElementSibling !== list) {
      parent.insertBefore(btnWrap, list.nextSibling);
    }
    btnWrap.classList.add('wplus-loadmore-wrap');
  }

  function resolveListFor(anchor) {
    const wrap = anchor.closest('[data-selector]');
    if (wrap) {
      const key = wrap.getAttribute('data-selector');
      const matches = Array.from(document.querySelectorAll(key));
      return matches.find(isVisible) || matches[0] || null;
    }
    const c = anchor.closest('.pf-slider, .pf-collection, .pf-grid, .pf-c');
    const tiles = c ? c.querySelectorAll(TILE_SEL) : [];
    return tiles.length ? tiles[0].parentElement : null;
  }

  async function handleLoadMore(e) {
    const a = e.target.closest('a[href*="page="]');
    if (!a) return;

    const list = resolveListFor(a);
    if (!list) return; // not our control

    if (e.metaKey || e.ctrlKey || e.button === 1) return; // new tab allowed
    e.preventDefault(); e.stopImmediatePropagation();

    if (a.dataset.loading === '1') return;
    a.dataset.loading = '1';

    const old = a.textContent || 'Load more';
    const currentHref = normalize(a.href);
    a.textContent = 'Loading…';

    try {
      const res  = await fetch(a.href, { credentials:'same-origin' });
      const html = await res.text();
      const doc  = new DOMParser().parseFromString(html, 'text/html');

      // Find the same list in the fetched document
      let nextList = null;
      const wrap = a.closest('[data-selector]');
      if (wrap) {
        const selectorKey = wrap.getAttribute('data-selector');
        const candidates = Array.from(doc.querySelectorAll(selectorKey))
          .map(el => ({ el, n: el.querySelectorAll(TILE_SEL).length }))
          .sort((A,B) => B.n - A.n);
        nextList = candidates[0]?.el || null;
      }
      if (!nextList) {
        const candidates = Array.from(doc.querySelectorAll('.pf-slider, .pf-collection, .pf-grid, .pf-c'))
          .map(el => ({ el, n: el.querySelectorAll(TILE_SEL).length }))
          .filter(x => x.n > 0)
          .sort((A,B) => B.n - A.n);
        nextList = candidates[0]?.el || null;
      }
      if (!nextList) throw new Error('No matching list on next page');

      const newTiles = Array.from(nextList.querySelectorAll(TILE_SEL));

      // --- DEDUPE by variant id ---
      const seen = new Set();
      list.querySelectorAll('.wplus-btn[data-wplus-variant-id]').forEach(b => {
        const id = b.getAttribute('data-wplus-variant-id');
        if (id) seen.add(String(id));
      });

      let appended = 0;
      newTiles.forEach(node => {
        const clone = document.importNode(node, true);
        const btn   = clone.querySelector('.wplus-btn[data-wplus-variant-id]');
        const vid   = btn && btn.getAttribute('data-wplus-variant-id');
        if (!vid || !seen.has(String(vid))) {
          list.appendChild(clone);
          if (vid) seen.add(String(vid));
          appended++;
        }
      });
      dbg('current:', currentHref, 'found:', newTiles.length, 'appended:', appended);

      // --- NEXT LINK (scoped + normalized) ---
      const nextWrap = nextList.closest('[data-selector]') || doc;
      const nextLink = Array.from(nextWrap.querySelectorAll('a[href*="page="]'))
        .find(x => /load\s*more/i.test(text(x)));   // only the "Load more" control
      const nextHref = nextLink ? normalize(nextLink.href) : null;
      dbg('nextHref:', nextHref, 'lastHref:', a.dataset.lastHref);

      // --- LOOP / END GUARDS ---
      if (!nextHref || appended === 0 || nextHref === currentHref || nextHref === a.dataset.lastHref) {
        dbg('end: remove button');
        a.remove();
      } else {
        a.href = nextHref;
        a.dataset.lastHref = nextHref;
        a.textContent = old;
        a.dataset.loading = '0';
        moveLoadMoreBelow(list, a);
      }

      // Hydrate CTAs for new tiles
      try { window.WPLUS?.renderTileCTAs?.(); } catch(_) {}
    } catch (err) {
      console.error('[WPLUS] append failed; fallback', err);
      location.href = a.href;
    }
  }

  ['click','pointerup','mouseup','touchend'].forEach(t =>
    document.addEventListener(t, handleLoadMore, true)
  );

  console.log('WPLUS append + reposition (dedupe & loop-guard) armed (iframe). Toggle window.WPLUS_DEBUG_APPEND=true for logs.');
})();



/* ===== DETAIL MODAL ===== */

(function () {
  const modal   = document.getElementById('wplusqv-modal');
  const content = document.getElementById('wplusqv-content');

  function openModal(){ modal.hidden=false; document.body.style.overflow='hidden'; }
  function closeModal(){ modal.hidden=true;  document.body.style.overflow=''; content.innerHTML=''; }
  // Close after other handlers/UI updates complete, regardless of cancelation
  function closeModalSoon(){
    // next frame, then microtask, so add/remove/buy handlers can finish first
    requestAnimationFrame(() => queueMicrotask(() => closeModal()));
  }

  function initQuickviewCarousel(root){
    const track=root.querySelector('.wplusqv-track');
    const prev=root.querySelector('.wplusqv-prev');
    const next=root.querySelector('.wplusqv-next');
    if(!track) return;
    const step=()=>track.clientWidth||800;
    prev?.addEventListener('click',()=>track.scrollBy({left:-step(),behavior:'smooth'}));
    next?.addEventListener('click',()=>track.scrollBy({left: step(),behavior:'smooth'}));
  }

  function isVariantSelected(variantId) {
    if (!variantId) return false;
    const id = String(variantId);
    if (document.querySelector(`.wplus-btn.wplus-selected[data-wplus-variant-id="${CSS.escape(id)}"]`)) {
      return true;
    }
    try {
      if (window.top?.document?.querySelector(
        `.wplus-btn.wplus-selected[data-wplus-variant-id="${CSS.escape(id)}"]`
      )) return true;
    } catch (_) {}
    return false;
  }
  function isOptimisticallySelected(variantId){
    try{
      const exp = window.WPLUS_OPTIMISM?.adds?.get(String(variantId));
      return !!exp && exp > Date.now();
    }catch(_){ return false; }
  }
  function isOwned(variantId, productId){
    const S=window.WPLUS_OWNED||{}; const V=S.variants||new Set(); const P=S.products||new Set();
    return (variantId && V.has(String(variantId))) || (productId && P.has(String(productId)));
  }
  function getRemainingPoints(){
    try{ if (window.WPLUS?.getRemainingPoints) return +window.WPLUS.getRemainingPoints()||0; }catch(_){}
    const n=+document.getElementById('wplus-points-remaining')?.textContent||0;
    return isNaN(n)?0:n;
  }
  function btnIds(btn){
    return {
      variantId: btn.getAttribute('data-wplus-variant-id') || btn.dataset.wplusVariantId ||
                 btn.getAttribute('data-variant-id') || btn.dataset.variantId || '',
      productId: btn.getAttribute('data-wplus-product-id') || btn.dataset.wplusProductId || ''
    };
  }
  function setOwned(btn){
    btn.classList.remove('wplus-btn--buy','wplus-selected');
    btn.classList.add('wplus-btn--owned');
    btn.dataset.wplusMode='owned';
    btn.innerHTML='<span class="wplus-owned-ico" aria-hidden="true">✓</span><span class="wplus-owned-label">Owned</span>';
  }

  function syncModalCTA(root = content){
    const btn = root.querySelector('.wplus-btn'); 
    if (!btn) return;

    const cost = +(btn.getAttribute('data-wplus-cost') || btn.dataset.wplusCost || btn.getAttribute('data-cost') || btn.dataset.cost || '0') || 0;
    const { variantId, productId } = btnIds(btn);

    if (isOwned(variantId, productId)){ 
      setOwned(btn); 
      return; 
    }

    if (variantId && (isVariantSelected(variantId) || isOptimisticallySelected(variantId))){
      btn.classList.remove('wplus-btn--buy','wplus-btn--owned');
      btn.classList.add('wplus-selected');
      btn.dataset.wplusMode = '';
      btn.textContent = 'Remove';
      return;
    }

    const remaining = getRemainingPoints();

    // --- BUY branch (updated): show how many points short ---
    if (cost>remaining){
      const miss = Math.max(0, cost - remaining);
      btn.classList.add('wplus-btn--buy');
      btn.classList.remove('wplus-btn--owned','wplus-selected');
      btn.dataset.wplusMode='buy';
      btn.innerHTML =
        'Buy&nbsp;<span class="wplus-miss">· ' +
          '<span class="wplus-miss-pts">' + miss + ' PTS</span>' +
        '</span>';
    } else {
      // ADD branch (unchanged)
      btn.classList.remove('wplus-btn--buy','wplus-btn--owned','wplus-selected');
      btn.dataset.wplusMode = '';
      btn.innerHTML = 'ADD&nbsp;<span class="wplus-pts">· ' + String(cost) + ' PTS</span>';
    }
  }

  // Capture-phase click handler (existing behavior)
  document.addEventListener('click', async (e)=>{
    if (e.target.closest('[data-wplusqv-close]')){ closeModal(); return; }

    const trigger=e.target.closest('.wplusqv-detail-btn');
    if (trigger){
      e.preventDefault();
      const url=(trigger.dataset.detailUrl||'').trim(); if(!url) return;
      openModal(); content.textContent='Loading…';
      try{
        const quickUrl=url+(url.includes('?')?'&':'?')+'view=wplus-quick';
        const html=await fetch(quickUrl,{headers:{'X-Requested-With':'XMLHttpRequest'},cache:'no-store',credentials:'same-origin'}).then(r=>r.text());
        content.innerHTML=html;
        content.querySelectorAll('.wplusqv-fullpage').forEach(a=>{a.setAttribute('target','_blank');a.setAttribute('rel','noopener');});
        initQuickviewCarousel(content);
        syncModalCTA(content);
      }catch(err){
        console.error('[WPLUSQV] load error',err);
        content.innerHTML='<p>Could not load product details.</p>';
      }
      return;
    }

    const addBtn=e.target.closest('#wplusqv-content .wplus-btn');
    if (addBtn){
      const mode=addBtn.dataset?.wplusMode||'';
      if (mode==='owned'){
        e.preventDefault();
        try{ window.top.document.getElementById('open-downloads-modal')?.click(); }catch(_){}
        closeModalSoon();
        return;
      }
      // ADD / REMOVE / BUY → allow their handlers to run, then close
      closeModalSoon();
      return;
    }
  }, true); // capture

  // capture-phase pointerup fallback — ensures closing for ADD even if click is canceled
  document.addEventListener('pointerup', (e)=>{
    const btn = e.target.closest('#wplusqv-content .wplus-btn');
    if (!btn) return;
    closeModalSoon();
  }, true); // capture

  document.addEventListener('wplus:cart-updated', ()=>syncModalCTA(content), false);
  window.addEventListener('storage', ()=>syncModalCTA(content), false);
  window.addEventListener('message', (e)=>{
    const d=e&&e.data;
    if (d && d.__wplus__ && d.channel==='wplus-v1') syncModalCTA(content);
  }, false);

  document.addEventListener('keydown',(e)=>{ if(e.key==='Escape' && !modal.hidden) closeModal(); });
})();





/* ===== W+ MENU NAV - Sidebar & Pills logic (desktop fixed + mobile pills) ===== */
(function(){
  const nav   = document.getElementById('wplus-nav');
  const pills = document.getElementById('wplus-mobile-pills');

  if (!nav && !pills) return;

  document.documentElement.classList.add('wplus-has-sidenav');

  const PAD_SELECTOR = '[data-pf-type="Section"], .pf-section, section';

  // --- helpers -------------------------------------------------------
  const cssInt = (name, fallback)=> {
    const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    const n = parseInt(v, 10);
    return Number.isFinite(n) ? n : fallback;
  };
  const isDesktop = () => window.matchMedia('(min-width:1100px)').matches;

  // find the PageFly/section node that holds the sidebar
  const navSection = nav ? nav.closest(PAD_SELECTOR) : null;

  // does el appear AFTER the sidebar section in document order?
  function isAfterSidebar(el){
    if (!navSection || !el) return true; // fail-soft: if we can't find the anchor, allow
    const rel = navSection.compareDocumentPosition(el);
    return !!(rel & Node.DOCUMENT_POSITION_FOLLOWING);
  }

  function padOne(el){
    if (!(el instanceof HTMLElement)) return;
    if (nav && el.contains(nav)) return;      // never pad the block that CONTAINS the sidebar
    if (!isAfterSidebar(el)) return;          // don't pad anything ABOVE the sidebar
    el.classList.add('wplus-nav-pad');
  }

  function padAll(){
    document.querySelectorAll(PAD_SELECTOR).forEach(padOne);
  }

  // smooth scroll
  function scrollToSel(sel){
    const el = document.querySelector(sel);
    if (!el) return;
    const topbar = cssInt('--wplus-topbar-h', 64);
    const extra  = isDesktop() ? 12 : 56;
    const y = window.scrollY + el.getBoundingClientRect().top - topbar - extra;
    window.scrollTo({ top: Math.max(0, y), behavior:'smooth' });
  }

  const KEY_TO_SEL = {
    new:     '#sec-new',
    best:    '#sec-best',
    limited: '#sec-limited',
    ai:      '#sec-ai',
    c1lut:   '#sec-c1lut',
    'c1lut-best': '#sec-c1lut-best',
  };

  let manualUntil = 0;
  function setActive(key, manual=false){
    if (manual) manualUntil = Date.now() + 800;
    if (nav)   nav.querySelectorAll('.wplus-sidenav__item')
      .forEach(b => b.classList.toggle('is-active', b.dataset.nav === key));
    if (pills) pills.querySelectorAll('.pill')
      .forEach(b => b.classList.toggle('is-active', b.dataset.nav === key));
  }

  function observeSections(){
    const entries = Object.entries(KEY_TO_SEL)
      .map(([k,sel]) => [k, document.querySelector(sel)])
      .filter(([,el]) => !!el);

    if (!entries.length) return;

    const topbar = cssInt('--wplus-topbar-h', 64);
    const obs = new IntersectionObserver((list) => {
      if (Date.now() < manualUntil) return;
      let best = null, max = 0;
      list.forEach(en => {
        if (en.isIntersecting && en.intersectionRatio > max){ max = en.intersectionRatio; best = en.target; }
      });
      if (!best) return;
      const hit = entries.find(([,el]) => el === best);
      if (hit) setActive(hit[0], false);
    }, {
      root: null,
      rootMargin: `-${topbar + 20}px 0px -55% 0px`,
      threshold: [0.25, 0.6, 0.9]
    });

    entries.forEach(([,el]) => obs.observe(el));
  }

  function bindClicks(container){
    container.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-target],[data-action]');
      if (!btn) return;

      if (btn.dataset.action === 'downloads'){
        e.preventDefault();
        try { (window.top || window).document.getElementById('open-downloads-modal')?.click(); } catch(_){}
        return;
      }

      const sel = btn.getAttribute('data-target');
      const key = btn.getAttribute('data-nav');
      if (sel){
        e.preventDefault();
        setActive(key, true);
        scrollToSel(sel);
      }
    }, true);
  }

  // --- keep pills left on small, centered on wider when they FIT ----
  function syncPillAlignment(){
    if (!pills) return;
    // Only apply this logic on the mobile/tablet range
    const mobile = !isDesktop();
    if (!mobile){
      pills.style.justifyContent = ''; // let desktop CSS handle
      return;
    }
    // Center only when the row fits; otherwise anchor left
    const fits = pills.scrollWidth <= pills.clientWidth + 1;
    pills.style.justifyContent = fits ? 'center' : 'flex-start';
  }

  function init(){
    padAll();

    // Make the section that holds the pills sticky-safe
    if (pills){
      const wrap = pills.closest(PAD_SELECTOR) || pills.parentElement;
      if (wrap) wrap.classList.add('wplus-sticky-wrap');
      bindClicks(pills);
      syncPillAlignment();
    }

    if (nav) bindClicks(nav);
    observeSections();

    
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Re-pad on resize + re-evaluate pill alignment
  let t = null;
  window.addEventListener('resize', () => {
    clearTimeout(t);
    t = setTimeout(() => { padAll(); syncPillAlignment(); }, 120);
  });

  // Also re-check after fonts load (widths can change)
  try { document.fonts?.ready.then(syncPillAlignment); } catch(_){}

  // If available, observe the rail for width/content changes
  if (window.ResizeObserver && pills){
    const ro = new ResizeObserver(syncPillAlignment);
    ro.observe(pills);
  }

  // PageFly often injects new sections; pad them only if they’re AFTER the sidebar
  const mo = new MutationObserver((muts) => {
    muts.forEach(m => {
      m.addedNodes && m.addedNodes.forEach(n => {
        if (!(n instanceof HTMLElement)) return;
        if (n.matches?.(PAD_SELECTOR)) padOne(n);
        n.querySelectorAll?.(PAD_SELECTOR).forEach(padOne);

        // re-assert sticky-safe and alignment if the pills exist
        if (pills){
          const wrap = pills.closest(PAD_SELECTOR) || pills.parentElement;
          wrap?.classList.add('wplus-sticky-wrap');
          syncPillAlignment();
        }
      });
    });
  });
  mo.observe(document.body, { childList: true, subtree: true });
})();

/* ===== W+ points-ready gate: reveal page only when points are hydrated ===== */
(function(){
  /* LOGIN GUARD — use storefront login, not /account/login */
  const isLoggedIn = document.documentElement.dataset.wplusLoggedIn === '1';
  if (!isLoggedIn) {
    const hub = '/pages/w';
    const to  = 'account:a:dashboard'; // '' if you don’t use a hash route
    const qp  = to ? ('?to=' + encodeURIComponent(to)) : '';
    location.replace('/customer_authentication/login?return_to=' + encodeURIComponent(hub + qp));
    return; // stop the gate, we’re redirecting
  }
  /* END LOGIN GUARD */

  const PRE_ID = 'wplus-pre';
  let revealed = false;

  function reveal(){
    if (revealed) return;
    revealed = true;
    const pre = document.getElementById(PRE_ID);
    pre?.classList.add('is-done');
    document.documentElement.classList.remove('wplus-pre');
    setTimeout(() => {
      document.getElementById('wplus-pre')?.remove();
      document.getElementById('wplus-pre-css')?.remove();
    }, 240);
  }

  function pointsReady(){
    try{
      const rem = window.WPLUS?.getRemainingPoints?.();
      if (!Number.isFinite(rem)) return false;
      const btns = document.querySelectorAll('.wplus-btn');
      if (!btns.length) return false;
      if (document.querySelector('.wplus-btn .wplus-pts')) return true;
      if (document.querySelector('.wplus-btn.wplus-selected, .wplus-btn.wplus-btn--owned, .wplus-btn[data-wplus-mode="buy"]')) return true;
      return false;
    }catch(_){ return false; }
  }

  let t = null;
  function schedule(ms=80){
    clearTimeout(t);
    t = setTimeout(() => { if (pointsReady()) reveal(); }, ms);
  }

  document.addEventListener('wplus:cart-updated', () => schedule(30));
  document.addEventListener('wplus:state-sync',   () => schedule(30));
  window.addEventListener('load',                 () => schedule(60));

  (function patchRenderHook(){
    const tryPatch = () => {
      const r = window.WPLUS?.renderTileCTAs;
      if (typeof r === 'function' && !r.__wplusPatched){
        const orig = r;
        const wrapped = function(...args){
          const out = orig.apply(this, args);
          schedule(20);
          return out;
        };
        wrapped.__wplusPatched = true;
        window.WPLUS.renderTileCTAs = wrapped;
        return true;
      }
      return false;
    };
    if (!tryPatch()){
      const iv = setInterval(() => { if (tryPatch()) clearInterval(iv); }, 50);
      setTimeout(() => clearInterval(iv), 5000);
    }
  })();

  const mo = new MutationObserver(() => schedule(40));
  mo.observe(document.body, { subtree:true, childList:true, characterData:true });

  // Never reveal to logged-out visitors
  setTimeout(function(){
    if (document.documentElement.dataset.wplusLoggedIn === '1') reveal();
  }, 10000);
})();


/* ===== W+ Account trigger (mobile-only) + popover (clones Account items from left nav) ===== */
(function(){
  const POP_ID = 'wplus-account-pop';
  const MOUNT_ID = 'wplus-acc-mount';
  const mq = window.matchMedia('(max-width:1099.98px)');
  let trigger = null, built = false, enabled = false;

  function getNav(){ return document.getElementById('wplus-nav'); }
  function getMount(){ return document.getElementById(MOUNT_ID); }

  /* create/destroy the trigger only on mobile */
  function createTrigger(){
    if (trigger || !getMount()) return;
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'dl-pill';           // reuse your pill styling
    btn.dataset.action = 'account-menu';
    btn.setAttribute('aria-haspopup','menu');
    btn.setAttribute('aria-expanded','false');
    btn.textContent = 'Account';
    getMount().replaceWith(btn);
    trigger = btn;
  }
  function destroyTrigger(){
    if (!trigger) return;
    const ph = document.createElement('span');
    ph.id = MOUNT_ID;
    trigger.replaceWith(ph);
    trigger = null;
  }

  /* pull items from the existing left nav > Account section */
  function getAccountItems(){
    const nav = getNav();
    if (!nav) return [];
    const title = [...nav.querySelectorAll('.wplus-sidenav__title')]
      .find(t => t.textContent.trim().toLowerCase() === 'account');
    if (!title) return [];
    const out = [];
    for (let el = title.nextElementSibling; el && !el.classList.contains('wplus-sidenav__title'); el = el.nextElementSibling){
      if (el.classList.contains('wplus-sidenav__item')) out.push(el);
    }
    return out;
  }

  /* build/teardown the popover */
  function buildPopover(){
    if (built) return;
    const pop = document.createElement('div');
    pop.id = POP_ID;
    pop.hidden = true;
    pop.setAttribute('role','menu');
    pop.innerHTML = '<div class="wplus-acc-wrap"></div>';
    document.body.appendChild(pop);

    const wrap = pop.querySelector('.wplus-acc-wrap');
    getAccountItems().forEach(src => {
      const node = src.cloneNode(true);
      node.classList.add('wplus-acc-item');
      node.setAttribute('role','menuitem');

      if (node.tagName === 'A'){
        node.addEventListener('click', () => close(), { once:true });
      } else if (node.tagName === 'BUTTON'){
        node.addEventListener('click', (e) => {
          e.preventDefault();
          if (node.dataset.action === 'downloads'){
            try { (window.top||window).document.getElementById('open-downloads-modal')?.click(); } catch(_){}
          }
          close();
        });
      }
      wrap.appendChild(node);
    });

    built = true;
  }
  function teardownPopover(){
    document.getElementById(POP_ID)?.remove();
    built = false;
  }

  /* open/close + positioning */
  function position(){
    const pop = document.getElementById(POP_ID); if (!pop || !trigger) return;
    pop.style.visibility = 'hidden';
    pop.hidden = false;

    const r = trigger.getBoundingClientRect();
    const naturalW = Math.max(240, r.width);
    pop.style.minWidth = naturalW + 'px';

    const left = Math.max(12, Math.min(window.innerWidth - naturalW - 12, r.left)) + window.scrollX;
    const top  = r.bottom + 8 + window.scrollY;
    pop.style.left = left + 'px';
    pop.style.top  = top  + 'px';
    pop.style.visibility = '';
  }
  function open(){
    buildPopover();
    position();
    const pop = document.getElementById(POP_ID);
    pop.hidden = false;
    document.documentElement.classList.add('wplus-acc-open');
    trigger.setAttribute('aria-expanded','true');
    addGlobals();
  }
  function close(){
    const pop = document.getElementById(POP_ID);
    if (!pop) return;
    pop.hidden = true;
    document.documentElement.classList.remove('wplus-acc-open');
    trigger?.setAttribute('aria-expanded','false');
    removeGlobals();
  }

  /* global listeners */
  function onDocClick(e){
    const pop = document.getElementById(POP_ID);
    if (!pop || pop.hidden) return;
    if (!pop.contains(e.target) && !trigger.contains(e.target)) close();
  }
  function onKey(e){ if (e.key === 'Escape'){ e.preventDefault(); close(); try{ trigger.focus(); }catch(_){} } }
  function onWinResize(){ close(); }
  function onWinScroll(){ close(); }

  function addGlobals(){
    document.addEventListener('click', onDocClick, true);
    document.addEventListener('keydown', onKey, true);
    window.addEventListener('resize', onWinResize);
    window.addEventListener('scroll', onWinScroll, { passive:true });
  }
  function removeGlobals(){
    document.removeEventListener('click', onDocClick, true);
    document.removeEventListener('keydown', onKey, true);
    window.removeEventListener('resize', onWinResize);
    window.removeEventListener('scroll', onWinScroll, { passive:true });
  }

  function onTrigger(e){
    e.preventDefault();
    const pop = document.getElementById(POP_ID);
    if (pop && !pop.hidden) close(); else open();
  }

  /* enable/disable by viewport */
  function enable(){
    if (enabled) return;
    createTrigger();
    if (!trigger) return;          // nav not ready? we'll try again on next tick
    enabled = true;
    trigger.addEventListener('click', onTrigger);
  }
  function disable(){
    if (!enabled) return;
    enabled = false;
    trigger?.removeEventListener('click', onTrigger);
    close();
    teardownPopover();
    destroyTrigger();
  }

  function update(){
    // make sure nav exists before enabling (PageFly can hydrate late)
    if (mq.matches && getNav()) enable(); else disable();
  }

  mq.addEventListener('change', update);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update);
  else update();

  // In case PageFly injects #wplus-nav later:
  const mo = new MutationObserver(() => update());
  mo.observe(document.body, { childList:true, subtree:true });
})();


/* ========================HELP MODAL ========================== */

// Woodland+ Points Help — JS only (no CSS injection)
(function () {
  if (window.__WPLUS_PH__) return;
  window.__WPLUS_PH__ = true;

  var MODAL_ID = 'wplus-points-help';

  function getRemainingPoints() {
    try {
      if (window.WPLUS && typeof WPLUS.getRemainingPoints === 'function') {
        return Math.max(0, +WPLUS.getRemainingPoints() || 0);
      }
    } catch (_) {}
    var n = parseInt((document.getElementById('wplus-points-remaining') || {}).textContent || '0', 10);
    return isNaN(n) ? 0 : n;
  }

  function ensureMarkup() {
    var modal = document.getElementById(MODAL_ID);
    if (modal) return modal;

    var html = `
      <div id="${MODAL_ID}" hidden role="dialog" aria-modal="true" aria-labelledby="ph-title">
        <div class="ph-backdrop" data-ph-close></div>

        <div class="ph-dialog" role="document">
          <header class="ph-header">
            <h2 class="ph-title" id="ph-title">Woodland Plus Help</h2>

            <!-- Points pill (same style as top bar, reads “300 points available”) -->
            <div class="wplus-points-wrap">
              <div class="wplus-points-pill" role="status" aria-live="polite">
                <span class="wplus-ico" aria-hidden="true">
                  <svg viewBox="0 0 24 24" width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 11h18v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-9Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"></path>
                    <path d="M3 8h18v3H3zM12 8v14" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M9.2 6.5C7.6 6.5 6 5.3 6 4.1S7.1 2 8.6 2c2 .1 2.8 3.1 3.1 4.5M14.8 6.5c1.6 0 3.2-1.2 3.2-2.4S16.9 2 15.4 2c-2 .1-2.8 3.1-3.1 4.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"></path>
                  </svg>
                </span>
                <span class="wplus-tgroup">
                  <strong id="wplusph-balance" class="wplus-points">0</strong>
                  <span class="wplus-label">points available</span>
                </span>
              </div>
            </div>

            <button class="ph-close" type="button" aria-label="Close" data-ph-close>✕</button>
          </header>

          <div class="ph-body">
            <div class="ph-columns">

              <section class="ph-card ph-col">
                <h3 class="ph-h3">How to redeem your points</h3>
                <ol class="ph-steps">
                  <li>
                    <div>Tap <strong>ADD · XX PTS</strong> on any pack. It moves to <strong>Selected Packs</strong> and your visible balance goes down. <em>Points aren’t actually deducted until you redeem.</em></div>
                  </li>
                  <li>
                    <div>Open <strong>Selected Packs</strong> → tap <strong>Redeem</strong>. You’ll land on checkout with those packs marked <strong>free</strong>. Complete checkout and download your packs.</div>
                  </li>
                  <li>
                    <div>Short on points? You’ll see <strong>Buy</strong> instead of Add. Tap it to open the product page and add to cart. At checkout, packs added with points are <strong>free</strong>; you only pay for the purchased pack (with your <strong>40% member discount</strong>).</div>
                  </li>
                </ol>
              </section>

              <section class="ph-card ph-col">
                <h3 class="ph-h3">Owned packs</h3>
                <ul class="ph-list">
                  <li>Packs you’ve already purchased show an <strong>Owned</strong> badge and don’t cost points.</li>
                  <li>Tapping <strong>Owned</strong> opens your <strong>Downloads / Library</strong> where you can use the <strong>Download</strong> button.</li>
                  <li>You can also open <strong>Library</strong> from the navigation (on mobile: tap <strong>Account</strong> in the top bar) <strong>to download your packs</strong>.</li>
                </ul>
              </section>

              <section class="ph-card ph-col">
                <h3 class="ph-h3">Helpful tips</h3>
                <ul class="ph-list">
                  <li>Your current balance is always visible in the top bar.</li>
                  <li>The <strong>ADD · XX PTS</strong> button shows the exact cost in points.</li>
                  <li>Tap <strong>Details</strong> to see compatibility and before/after images.</li>
                </ul>
              </section>

              <section class="ph-card ph-col">
                <h3 class="ph-h3">Pack of the month</h3>
                <ul class="ph-list">
                  <li>The current monthly pack is pinned to the top of your member dashboard. It costs <strong>0 points</strong>—add it and redeem like any other pack.</li>
                  <li>Points are added automatically each month while your membership is active.</li>
                  <li>Watch for promos—<strong>active members may receive bonus points during special offers!</strong></li>
                </ul>
              </section>

              <section class="ph-col ph-footer">
                <a class="ph-cta" href="https://woodlandpresets.com/pages/contact-page" target="_blank">Need help? Contact us</a>
              </section>

            </div>
          </div>
        </div>
      </div>`;

    var wrapper = document.createElement('div');
    wrapper.innerHTML = html;
    modal = wrapper.firstElementChild;
    document.body.appendChild(modal);
    return modal;
  }

  var modal = ensureMarkup();
  var numEl = document.getElementById('wplusph-balance');

  function updateBalance(){ try { numEl.textContent = String(getRemainingPoints()); } catch(_){} }
  function open(){ updateBalance(); modal.hidden = false; document.documentElement.style.overflow = 'hidden'; }
  function close(){ modal.hidden = true; document.documentElement.style.overflow = ''; }

  // Open triggers
  document.addEventListener('click', function(e){
    var t = e.target && (e.target.closest('[data-modal-open="points-help"]') || e.target.closest('[data-action="points-help"]'));
    if (!t) return;
    e.preventDefault();
    open();
  }, true);

  // Close (backdrop or ✕)
  modal.addEventListener('click', function(e){
    if (e.target.matches('[data-ph-close]') || e.target.classList.contains('ph-backdrop')) close();
  }, true);

  // Close on Esc
  document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !modal.hidden) close(); });

  // Live balance while open
  document.addEventListener('wplus:cart-updated', function(){ if (!modal.hidden) updateBalance(); });
})();

})();
